<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/admin/chamadas/${$route.params.idCall}/inscricoes`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para listagem das
              startups</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-5">
          <card shadow type="secondary" class="text-center">
            <div class="card-profile-image">
              <img
                v-if="startup.logo"
                :src="startup.logo.url"
                class="card-image my-3"
                alt="..."
              />
            </div>
            <div class="card-body mt-9 py-0">
              <h2 class="card-title text-orange mb-1">
                {{ startup.name }}
              </h2>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i>{{ startup.city || "..." }},
                  {{ startup.state || "..." }}
                </div>
                <p class="ml-2 text-sm mt-3">
                  <i class="fas fa-quote-left mr-1"></i
                  >{{ startup.one_sentence_pitch
                  }}<i class="fas fa-quote-right ml-1"></i>
                </p>
                <div v-if="startup.subscription">
                  <div class="h5 font-weight-300 mb-1">
                    <i class="fas fa-user-tie mr-1"></i> Responsável:
                    {{ startup.subscription.responsible_name }}
                  </div>
                  <div class="mt-3">
                    <base-button
                      v-if="startup.subscription.is_visible"
                      type="danger"
                      size="sm"
                      @click="handleSubmitToggleStatus()"
                    >
                      <i class="fas fa-eye-slash"></i> Ocultar da avaliação
                    </base-button>
                    <base-button
                      v-else
                      type="info"
                      size="sm"
                      @click="handleSubmitToggleStatus()"
                    >
                      <i class="fas fa-eye"></i> Exibir para avaliação
                    </base-button>
                    <p class="text-muted text-sm mt-2">
                      <i class="fas fa-info-circle mr-1"></i>
                      Atualmente a startup está
                      <badge
                        type="success"
                        v-if="startup.subscription.is_visible"
                      >
                        visível
                      </badge>
                      <badge type="danger" v-else> invisível </badge>
                      para avaliação dos investidores.
                    </p>
                  </div>
                </div>
              </div>
              <hr class="mb-4 mt-2" />
              <div v-if="startup.subscription" class="text-left">
                <div>
                  <h6 class="heading-small text-muted mb-4">Sobre a startup</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Setor(es) econômico(s) de
                    atuação:
                    <span class="text-muted">
                      {{ startup.sector }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Data de fundação:
                    <span class="text-muted">
                      {{ formatDate(startup.foundation) }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Estágio de maturidade
                    atual:
                    <span class="text-muted">
                      {{ stages[startup.stage] || startup.stage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Mercado principal de
                    atuação:
                    <span class="text-muted">
                      {{ startup.bussiness_strategy }}
                    </span>
                  </p>
                  <div class="mb-3" v-if="startup.subscription.startup_problem">
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Desafios mais
                      significativos:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.startup_problem }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.how_can_stars_help"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Como a Stars pode
                      ajudar?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.how_can_stars_help }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.responsible_phone"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Celular do responsável:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.responsible_phone }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.responsible_email"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> E-mail do responsável:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.responsible_email }}
                      </span>
                    </p>
                  </div>
                  <p
                    class="text-sm"
                    v-if="startup.subscription.already_participated_batch"
                  >
                    <i class="fas fa-arrow-right"></i> Já participou de outro
                    Batch Stars?
                    <span class="text-muted">
                      {{ startup.subscription.already_participated_batch }}
                    </span>
                  </p>
                </div>
                <hr class="my-4" />
                <div>
                  <h6 class="heading-small text-muted mb-4">Negócio</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Maior vantagem
                    competitiva:
                    <span class="text-muted">
                      {{ startup.subscription.product_competitive_advantage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Modelo de negócios:
                    <span class="text-muted">
                      {{ startup.subscription.product_bussiness_strategy }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Faturamento total do
                    último trimestre (em reais):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.last_quarters_revenue }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Tamanho de mercado 
                    (opcional):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.product_market_cap }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Clientes ativos que a 
                    startup possui atualmente:
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.active_clients }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Qual o valor de
                    investimento que a startup busca?
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.investment_sought }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Qual o percentual de 
                    equity oferecido? (máximo de 100%)
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.equity_offered }}%
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Problema ou necessidade
                    resolvida pela empresa:
                    <span class="text-muted">
                      {{ startup.subscription.product_market_problem }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Captable atual:
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.startup_equity }}
                    </span>
                  </p>
                  <p class="text-sm mb-1">
                    <i class="fas fa-arrow-right"></i> Website:
                    <span class="text-muted text-sm mb-0">
                      {{ getWebsiteUrl() }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-7 mt-lg-0 mt-3">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    <span class="text-warning">{{
                      startup.name || "Startup"
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <h6 class="heading-small text-muted mb-4">
              <i class="fas fa-comment-dots mr-1"></i> Breves Considerações
              <span class="text-warning">Stars</span>
            </h6>
            <div class="row">
              <div class="col-12">
                <div class="ci-container-edditable">
                  <quill-editor
                    v-model="model.considerations_stars"
                    :options="editorEdittable"
                  >
                  </quill-editor>
                </div>
                <div v-if="error" class="col-12 text-center mt-3">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
              </div>
              <div class="col-12 mt-3 text-right">
                <base-button
                  type="warning"
                  :custom="true"
                  size="sm"
                  @click="handleSubmit"
                  >Salvar considerações</base-button
                >
              </div>
            </div>
            <h6 class="heading-small text-muted mb-4">
              <i class="fas fa-sort-numeric-down mr-1"></i> Ordenação
            </h6>
            <div class="row">
              <div class="col-lg-6">
                <label class="form-control-label"
                  >Ranking
                  <i
                    class="fas fa-info-circle ml-1"
                    title="A ordenação das inscrições é feita com base no ranking em ordem decrescente"
                  ></i
                ></label>
                <base-input
                  type="number"
                  placeholder="Digite aqui"
                  v-model="model.score"
                ></base-input>
              </div>
              <div
                class="col-lg-6 mt-lg-4 pt-lg-3 pt-0 mt-0 text-center text-lg-left"
              >
                <base-button
                  type="primary"
                  :custom="true"
                  size="sm"
                  @click="handleSubmitScore"
                  >Salvar ranking</base-button
                >
              </div>
            </div>
            <hr class="my-4" />
            <h6 class="heading-small text-muted mb-4">
              <i class="fab fa-youtube mr-1"></i> Pitch video
            </h6>
            <div class="video-wrap">
              <div
                class="video-container"
                v-if="startup.subscription.startup_pitch_video_youtube_id"
              >
                <iframe
                  v-if="startup.subscription"
                  :src="
                    getUrl(startup.subscription.startup_pitch_video_youtube_id)
                  "
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                >
                </iframe>
              </div>
              <div class="text-center" v-else>
                <badge type="info"> Pitch vídeo não fornecido </badge>
              </div>
            </div>
            <hr class="my-4" />
            <div>
              <h6 class="heading-small text-muted mb-4">
                <i class="far fa-file-pdf mr-1"></i> Pitch deck
                <a
                  v-if="startup.subscription && startup.subscription.deck"
                  :href="startup.subscription.deck.url"
                  target="_blank"
                  class="btn btn-sm btn-primary float-right"
                >
                  <i class="fas fa-file-download"></i> Baixar
                </a>
              </h6>
              <div class="row mt-3">
                <div class="col text-center">
                  <div v-if="startup.subscription && startup.subscription.deck">
                    <pdf
                      style="margin: 0 auto; width: 90%; max-width: 700px"
                      ref="startupDeck"
                      :src="startup.subscription.deck.url"
                      :page="deck.page"
                      @num-pages="deck.pageCount = $event"
                      @page-loaded="deck.currentPage = $event"
                    ></pdf>
                    <div class="text-center mt-2">
                      <base-button
                        :iconOnly="true"
                        icon="fa fa-chevron-left"
                        size="sm"
                        class="mr-0"
                        @click="previousPage()"
                        :disabled="this.deck.page <= 1"
                      ></base-button>
                      <span class="mx-3 text-sm"
                        >{{ deck.currentPage }} / {{ deck.pageCount }}</span
                      >
                      <base-button
                        :iconOnly="true"
                        icon="fa fa-chevron-right"
                        size="sm"
                        class="mr-0"
                        @click="nextPage()"
                        :disabled="this.deck.page >= this.deck.pageCount"
                      ></base-button>
                    </div>
                  </div>
                  <div v-else>
                    <badge type="info"> Pitch deck não fornecido </badge>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";
import pdf from "vue-pdf";

export default {
  name: "inscricao-view",
  components: {
    pdf,
    quillEditor,
  },
  data() {
    return {
      model: {
        subscription_note_id: null,
        considerations_stars: "",
        score: 0,
      },
      isUpdate: false,
      startup: "",
      error: "",
      deck: {
        page: 1,
        currentPage: 0,
        pageCount: 0,
      },
      editorEdittable: {
        placeholder: "Escreva aqui as considerações...",
      },
      stages: {
        concept: "Ideação",
        validation: "Validação",
        traction: "Tração",
        scale: "Escala",
        other: "Outro",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
    });
    try {
      const { data: startup } = await api.get(
        `/adm/startup-call-subscriptions/${this.$route.params.idSubscription}`
      );
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!startup.logo) startup.logo = { url: defaultLogoPath };
      try {
        const links = JSON.parse(startup.subscription.product_more_information);
        if (Array.isArray(links)) {
          startup.subscription.product_more_information = links
            .map((link) => (link && link.link ? link.link : ""))
            .filter((link) => link && link.trim() !== "");
        } else if (links && links.link) {
          startup.subscription.product_more_information = [links.link];
        } else {
          startup.subscription.product_more_information = [];
        }
      } catch (e) {
        startup.subscription.product_more_information =
          startup.subscription.product_more_information &&
          startup.subscription.product_more_information.trim() !== ""
            ? [startup.subscription.product_more_information]
            : [];
      }
      this.startup = startup;
      const note = startup.subscription.note;
      if (note) {
        this.model.considerations_stars =
          startup.subscription.note.considerations_stars;
      }
      this.model.score = startup.subscription.score || 0;
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.$router.push(
        `/admin/chamadas/${this.$route.params.idCall}/inscricoes`
      );
    }
    loader.hide();
  },
  methods: {
    getWebsiteUrl() {
      if (
        !this.startup.subscription ||
        !this.startup.subscription.product_more_information
      ) {
        return "não informado";
      }

      const productInfo = this.startup.subscription.product_more_information;

      if (Array.isArray(productInfo)) {
        const firstItem = productInfo[0];
        if (!firstItem || firstItem === "" || firstItem === "undefined") {
          return "não informado";
        }
        return firstItem;
      }

      if (typeof productInfo === "string") {
        try {
          const parsed = JSON.parse(productInfo);
          if (parsed && parsed.link && parsed.link.trim() !== "") {
            return parsed.link;
          }
          return "não informado";
        } catch (e) {
          return productInfo && productInfo.trim() !== ""
            ? productInfo
            : "não informado";
        }
      }

      return "não informado";
    },
    async handleSubmit() {
      this.error = "";
      if (!this.model.considerations_stars) return;
      const loader = this.$loading.show({
        container: this.$refs.form_edit_container,
        width: 140,
        height: 140,
      });
      try {
        const data = { considerations_stars: this.model.considerations_stars };
        await api.put(
          `/adm/startup-call-subscriptions/${this.$route.params.idSubscription}`,
          data
        );
        this.$toasted.success("Considerações salvas com sucesso");
        this.$router.push(
          `/admin/chamadas/${this.$route.params.idCall}/inscricoes`
        );
      } catch (e) {
        this.error =
          "Ocorreu um erro ao salvar as considerações. Tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as considerações");
      }
      loader.hide();
    },
    async handleSubmitScore() {
      const loader = this.$loading.show({
        container: this.$refs.form_edit_container,
        width: 140,
        height: 140,
      });
      try {
        const data = { score: this.model.score };
        await api.put(
          `/adm/startup-call-subscriptions/${this.$route.params.idSubscription}`,
          data
        );
        this.$toasted.success("Índice de ordenação salvo com sucesso");
      } catch (e) {
        this.error =
          "Ocorreu um erro ao salvar o índice de ordenação. Tente novamente.";
      }
      loader.hide();
    },
    async handleSubmitToggleStatus() {
      const loader = this.$loading.show({
        container: this.$refs.form_edit_container,
        width: 140,
        height: 140,
      });
      try {
        const status = {
          is_visible: this.startup.subscription.is_visible ? 0 : 1,
        };
        const {
          data: { is_visible },
        } = await api.put(
          `/adm/startup-call-subscriptions/${this.$route.params.idSubscription}`,
          status
        );
        this.startup.subscription.is_visible = is_visible;
        this.$toasted.success("Alteração salva com sucesso");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao salvar a alteração");
      }
      loader.hide();
    },
    getUrl(youtubeVideoId) {
      return `https://www.youtube.com/embed/${youtubeVideoId}`;
    },
    nextPage() {
      if (this.deck.pageCount > this.deck.page) this.deck.page++;
    },
    previousPage() {
      if (this.deck.page > 1) this.deck.page--;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}

.estrelas {
  text-align: right;
  margin-top: 2px;
  margin-right: 3%;
}

.estrelas input[type="radio"] {
  display: none;
}

.estrelas label i.fa:before {
  content: "\f005";
  color: #ff4200;
  font-size: 1.8em;
}

.estrelas input[type="radio"]:checked ~ label i.fa:before {
  color: #ccc;
}

.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 50%;
}

.video-container iframe,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.video-wrap {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
</style>
<style>
.ci-container-edditable .quill-editor .ql-container,
.ci-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 8rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
